import { FC } from 'react'
import styled, { StyledProps } from 'styled-components'
import { sv } from '@ucheba/utils/helpers/styles/variables'
import { IImagesSliderProps } from './types'

const Block = styled.div`
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  z-index: 10;
`

const Item = styled.div<StyledProps<any>>`
  border: 1px solid ${sv.color.gray30};
  height: 8px;
  width: ${(props) => (props.active ? '16px' : '8px')};
  background-color: ${(props) => (props.active ? sv.color.white70 : sv.color.white15)};
  margin: 0 2px;
  border-radius: 4px;
  cursor: ${(props) => (props.active || props.disabled ? 'default' : 'pointer')};
`

const ImagesSlider: FC<IImagesSliderProps> = (props) => {
  const { items, onClick, activeIndex } = props

  return (
    <Block>
      {items.map((img, key) => {
        return (
          <Item
            key={key}
            active={key === activeIndex}
            disabled={!onClick}
            onClick={() => {
              if (onClick) {
                onClick(key, img)
              }
            }}
          />
        )
      })}
    </Block>
  )
}

export default ImagesSlider
